import $ from "jquery";
import JustValidate from 'just-validate';

export default () => {
  const body = document.body;
  const isValidPage =
    body.classList.contains('page-type-toolInvestimentoPage') ||
    body.classList.contains('page-type-toolPrevidenzaPage') ||
    body.classList.contains('page-type-toolFinanziamentoCasaPage');

  if (!isValidPage) return;

  const lang = document.documentElement.lang || 'it';

  const messages = {
    required: {
      it: 'Questo campo è obbligatorio.',
      de: 'Dieses Feld ist erforderlich.'
    },
    mortgageImportTooHigh: {
      it: "L'importo del mutuo non può superare l'80% del valore dell'immobile.",
      de: "Der Hypothekenbetrag darf 80% des Immobilienwerts nicht überschreiten."
    }
  };

  const main = document.querySelector('main');
  if (!main) return;

 const forms = Array.from(main.querySelectorAll('form'))
    .filter(f => !f.closest('#wee'));

  forms.forEach((form) => {
    const validator = new JustValidate(form, {
      validateBeforeSubmitting: false,
      errorLabelStyle: {
        background: '#D9534F',
        color: 'white',
        fontSize: '12px',
        padding: '4px 8px',
        borderRadius: '4px',
        position: 'relative',
        zIndex: '10',
        marginTop: '-4px',
        whiteSpace: 'nowrap',
      },
      errorLabelCssClass: 'input-tooltip-error',
      errorFieldCssClass: 'is-invalid',
      focusInvalidField: true,
      lockForm: true,
    });

    const fields = form.querySelectorAll('input[required], select[required], textarea[required]');
    const submitBtn = form.querySelector('[type="submit"]');

    const mortgageValueField = form.querySelector('input#mortgage-value');
    const mortgageImportField = form.querySelector('input#mortgage-import');

    let userHasInteracted = false;

    // 🔧 Interpreta valori < 1000 come migliaia
    const getNumericValue = (input) => {
        if (!input) return 0;
        let value = parseInt(input.value.replace(/\./g, ''));
        if (isNaN(value)) return 0;
        return value;
      };

    const isMortgageValid = () => {
      if (!mortgageValueField || !mortgageImportField) return true;
      const value = getNumericValue(mortgageValueField);
      const amount = getNumericValue(mortgageImportField);
      return value > 0 && amount <= value * 0.8;
    };

    const showMortgageError = (visible) => {
      let errorDiv = form.querySelector('.mortgage-import-error');
      if (!errorDiv && mortgageImportField) {
        errorDiv = document.createElement('div');
        errorDiv.className = 'mortgage-import-error';
        errorDiv.style.cssText = 'color:#D9534F; font-size:14px; margin-top:5px;';
        mortgageImportField.parentElement.appendChild(errorDiv);
      }
      if (errorDiv) {
        errorDiv.textContent = visible ? messages.mortgageImportTooHigh[lang] : '';
      }
    };

    const updateSubmitState = () => {
      const allRequiredFilled = Array.from(fields).every(field => {
        return field.type === 'checkbox' || field.type === 'radio'
          ? field.checked
          : field.value.trim() !== '';
      });

      const mortgageValid = isMortgageValid();

      if (userHasInteracted) {
        showMortgageError(!mortgageValid);
      }

      submitBtn.disabled = !(allRequiredFilled && mortgageValid);
    };

    // Rileva interazioni utente
    const trackUserInteraction = (field) => {
      if (!field) return;
      field.addEventListener('input', () => {
        userHasInteracted = true;
        updateSubmitState();
      });
    };

    trackUserInteraction(mortgageValueField);
    trackUserInteraction(mortgageImportField);

    // Validazione campi required
    fields.forEach(field => {
      const name = field.name || field.id;
      if (!name) return;

      if (getComputedStyle(field.parentElement).position === 'static') {
        field.parentElement.style.position = 'relative';
      }

      validator.addField(field, [
        {
          rule: 'required',
          errorMessage: messages.required[lang] || messages.required['it'],
        },
      ]);

      field.addEventListener('input', updateSubmitState);
      field.addEventListener('change', updateSubmitState);
    });

    // Regola personalizzata: mortgage-import < 80% mortgage-value
    if (mortgageImportField && mortgageValueField) {
      validator.addField(mortgageImportField, [
        {
          validator: () => isMortgageValid(),
          errorMessage: messages.mortgageImportTooHigh[lang],
        },
      ]);
    }

    updateSubmitState();

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!submitBtn.disabled) {
        form.submit();
      }
    });
  });
};
